<!--  -->
<template>
  <div class="Video">
    <div class="videoBox" :class="{ none: show }">
      <video
        id="VideoDom"
        src="../../assets/media/bacVideo.mp4"
        muted
        autoplay
      ></video>
      <div class="skip" :class="{ active: skip }" @click="toSwkk">跳过</div>
    </div>

    <div class="bacImg" v-show="0">
      <div class="btnn" @click="toSwkk">&emsp;进入展馆</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Video",
  components: {},
  data() {
    //这里存放数据
    return {
      skip: false,
      show: false,
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    toSwkk() {
      this.$router.push("/Home");
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    // 移动端和pc端的切换
    if (
      window.navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
    ) {
      // 移动端
      if (window.location.href.includes("YHT")) {
        window.location.href = window.location.href.replace("YHT", "YHTM");
        setTimeout(() => {
          location.reload(true);
        }, 200);
      }
    }
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    setTimeout(() => {
      this.skip = true;
    }, 3000);
    let dom = document.querySelector("#VideoDom");
    dom.addEventListener("ended", () => {
      this.show = true;
      this.$router.push("/Home");
    });
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='less' scoped>
.Video {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: absolute;
  background-image: url("../../assets/img/Home/bac.jpg");
  background-size: cover;

  top: 0;
  left: 0;
  .videoBox {
    background-color: #fff;
    transition: opacity 0.5s;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 30;
  }
  video {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 100%;
  }
  .skip {
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.3s;
    cursor: pointer;
    background-image: url("../../assets/img/skip.png");
    background-size: 100% 100%;
    position: absolute;
    bottom: 50px;
    right: 50px;
    width: 60px;
    height: 60px;
    line-height: 60px;
    text-align: center;
    font-size: 16px;
    color: #a50f0f;
  }
  .active {
    opacity: 1;
    pointer-events: auto;
  }
}
.bacImg {
  transition: opacity 0.5s;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 29;
  background-image: url("../../assets/img/HomeBac.jpg");
  background-size: 100% 100%;
  .btnn {
    cursor: pointer;
    position: absolute;
    bottom: 70px;
    left: 50%;
    transform: translateX(-50%);
    width: 302px;
    height: 140px;
    line-height: 190px;
    font-weight: 700;
    text-align: center;
    font-size: 24px;
    color: #930909;
    background-image: url("../../assets/img/HomeBtnn.png");
    background-size: 100% 100%;
  }
}
.none {
  opacity: 0;
  pointer-events: none;
}
</style>